import { render, staticRenderFns } from "./MintOrJoin.vue?vue&type=template&id=075d1355&scoped=true"
import script from "./MintOrJoin.vue?vue&type=script&lang=js"
export * from "./MintOrJoin.vue?vue&type=script&lang=js"
import style0 from "./MintOrJoin.vue?vue&type=style&index=0&id=075d1355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075d1355",
  null
  
)

export default component.exports